<template>
	<v-list dense v-if="is_search_results" two-line>

		<v-list-tile v-for="(result,idx) in results" :key="idx" @click="open(result)">
			<v-list-tile-content style="min-width: 80px; max-width: 80px; width: 80px;">
				<v-list-tile-title>
					{{date(result)}}
				</v-list-tile-title>
				<v-list-tile-sub-title>
					{{time(result)}}
				</v-list-tile-sub-title>
			</v-list-tile-content>
			<v-list-tile-content style="text-align: left;">
				<v-list-tile-title>
				{{title(result)}}
				</v-list-tile-title>
				<v-list-tile-sub-title>
				{{subtitle(result)}}
				</v-list-tile-sub-title>
			</v-list-tile-content>
		</v-list-tile>
		<v-divider></v-divider>
	</v-list>
</template>

<script>
import EventModel from '@/models/event.js'

export default {
	props: ["search", "url-prefix"],
	data () {
		return {
			channel: undefined,
			results: [],
		}
	},
	watch: {
		search (new_val) {
			var self = this;
			if (new_val != null && new_val.length > 2) {
  	  	this.channel.push("search", {search: new_val})
    		.receive("ok", (msg) => {
    			self.results = msg.results;
    		})
			}
		}
	},
	computed: {
		is_search_results () {
			if (this.search == null) return false;
      if (this.search.length > 2) return true;
      return false;
    },
	},
	methods: {
		open (event) {
			var url = "/dashboard/event/"
			if (typeof(this.urlPrefix) != "undefined" && this.urlPrefix != null) {
				url = this.urlPrefix;
			}

			this.$router.push(url + event.uuid);
		},
		title (event) {
			return EventModel.title(event);
		},
		subtitle (event) {
			return EventModel.subtitle(event);
		},
		date (event) {
			return EventModel.formatted_date(event);
		},
		time (event) {
			return EventModel.formatted_time(event);
		},
		ws_connect() {
			var self = this;
	    this.channel = this.$cloudserver.channel("events:search");
    	this.channel.join();
		}
	},
	mounted () {
		this.ws_connect();
	},
	beforeDestroy () {
		this.channel.leave();
	}
}
</script>